// Central brand config. Colors live in src/index.css (:root --brand*, --ink*, --surface*).
export const BRAND = {
  name: "MasterX",
  fullName: "MasterX HD",
  tagline: "Velocidade & Estabilidade",
  domain: "www.masterxhd.com.br",
  whatsappNumber: "558888692794",
  whatsappDisplay: "(88) 8869-2794",
  logoVertical: "/logo-vertical.png",
  logoHorizontal: "/logo-horizontal.png",
  logoIcon: "/logo-icon.png",
  webAreaUrl: "https://player.masterplayer.store/",
  partnerCode: "SKXDJY",
  links: {
    subscriberPortal: "http://painelmaster.app/portal",
  },
};
